module.exports = __webpack_public_path__ + "img/carousel_1.b9068520.png";